import React from "react";
import {
  IconTitleDescriptionActionCard,
  SectionContainerBase,
  TwoColumnSectionBase,
} from "@reusejs/react";

let sectionDetails = {
  title: "Want to Meet Us Personally?",
  description:
    "We will be happy to meet at our office location mentioned below",
};

let firstSectionData = {
  title: "Hyderabad",
  description: (
    <div>
      <p>7-1-28/1/A/1 PARK AVENUE 1,</p>
      <p>AMEERPET, SECUNDERABAD TELANGANA,</p>
      <p>
        <span className="text-black">Zip Code/Postal Code:</span> 500016
      </p>
    </div>
  ),
};

export default function Addresses() {
  return (
    <SectionContainerBase
      sectionContainerBaseClasses={{
        outerContainerStyles: "bg-gray-50 overflow-hidden py-10 md:py-24",
        innerContainerStyles: "max-w-7xl mx-auto px-4 sm:px-6 xl:px-0",
      }}
    >
      <Heading
        title={sectionDetails.title}
        description={sectionDetails.description}
      />
      <div className="mt-8">
        <TwoColumnSectionBase
          firstColumnEl={
            <IconTitleDescriptionActionCard
              title={firstSectionData.title}
              description={firstSectionData.description}
              itemTitleDescriptionCardBaseClasses={{
                titleWrapper: "text-left",
                titleStyles:
                  "text-lg md:text-3xl font-extrabold text-gray-900 md:leading-none md:tracking-tight lg:text-xl",
                descriptionWrapper: "text-left mt-2.5 md:mt-4 ",
                descriptionStyles:
                  "max-w-xl text-sm md:text-base text-gray-500",
              }}
            />
          }
          secondColumnEl={<div></div>}
          twoColumnSectionBaseClasses={{
            firstElWrapperStyles: "w-full md:w-1/2",
            secondElWrapperStyles:
              "w-full md:w-1/2 mt-4 sm:mt-0 self-stretch md:pl-16",
            columnsFlexWrapperStyles:
              "flex items-center  justify-between flex-col md:flex-row",
          }}
        />
      </div>
    </SectionContainerBase>
  );
}

const Heading = (props: any) => {
  return (
    <IconTitleDescriptionActionCard
      title={props.title}
      description={props.description}
      itemTitleDescriptionCardBaseClasses={{
        titleWrapper: "text-left",
        titleStyles:
          "text-xl md:text-3xl font-extrabold text-gray-900 sm:text-3xl sm:leading-none sm:tracking-tight lg:text-4xl",
        descriptionWrapper: "text-left mt-2.5 md:mt-4",
        descriptionStyles: "max-w-xl  text-base text-gray-500",
      }}
    />
  );
};
